<template>
  <div class="usc-calloutLink gutter-md mb">
    <div>
      <a :href="url" target="_blank">{{urltext}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalloutLink',
  props: ['title', 'urltext', 'url'],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';

  .usc-calloutLink {
    padding-top: 12px;
    padding-bottom: 10px;
    > div {
      border-left: 3px solid $cMaroon;
      padding-left: 20px;
      @media (min-width: $screen-sm-min) {
        padding-left: 50px;
      }
    }
    h4 {
      margin-bottom: 10px;
    }
    a {
      font-size: 20px;
      font-family: $fCaslon;
      line-height: 1.071;
      color: $cMaroon;
      text-decoration: none;
      word-wrap: break-word;
      display: block;
      @media (min-width: $screen-sm-min) {
        font-size: 28px;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/CalloutLink.vue